// zone.js DEVE ser o primeiro import — antes de qualquer código Angular.
// O UNPATCHED_EVENTS já está definido no index.html via inline script,
// que executa antes deste bundle. A ordem é garantida.
import 'zone.js';
// reflect-metadata: sem este polyfill, os `__metadata("design:paramtypes", ...)`
// que o TypeScript emite (emitDecoratorMetadata, tsconfig.json) são no-ops — o
// compilador JIT do Angular (@angular/compiler, via ts-loader sem @ngtools/webpack)
// não consegue resolver NENHUMA dependência de construtor sem isso, falhando com
// NG0202 no primeiro componente que injetar algo (ex.: ChangeDetectorRef em
// DashboardComponent). Precisa vir antes de qualquer import do @angular/core.
import 'reflect-metadata';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UpgradeModule, downgradeComponent, setAngularJSGlobal } from '@angular/upgrade/static';
import { AppModule } from './app/app.module';
import { AppService } from './app/services/app.service';

// Sem enableProdMode() o Angular roda em dev mode: change detection executa 2x
// por ciclo — custo dobrado em cada digest do runtime híbrido (AUT-6926).
// Detecção de ambiente por hostname, mesmo padrão de app/app.constants.js.
if (!document.location.hostname.includes('localhost')) {
  enableProdMode();
}

// ─── Estilos Tailwind (componentes Angular) ───────────────────────────────────
// Gera dist-angular/angular.bundle.css — carregado no index.html
// preflight desabilitado: zero impacto nas telas AngularJS legadas
import './styles/tailwind.css';
// ─────────────────────────────────────────────────────────────────────────────

// ─── Componentes migrados ────────────────────────────────────────────────────
// Convenção de nomenclatura:
//   Arquivo:   src-angular/app/nome-da-tela.component.ts
//   Seletor:   'app-nome-da-tela'
//   Diretiva:  module.directive('appNomeDaTela', downgradeComponent(...))
//   Template:  template: '<app-nome-da-tela></app-nome-da-tela>'
// ─────────────────────────────────────────────────────────────────────────────
import { DOWNGRADES } from './app/migrated-components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- global AngularJS injetado no runtime híbrido (§2.3); tipado na Exit Phase
declare var angular: any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ponte platformRef NgUpgrade (§2.3); tipado na Exit Phase
(window as any).angularPlatformRef = null;
setAngularJSGlobal(angular);

platformBrowserDynamic()
  // Coalescing: rajadas de eventos/microtasks disparam UM ciclo de CD (e um digest
  // do runtime híbrido) por frame, em vez de um por evento (AUT-6926).
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true, ngZoneRunCoalescing: true })
  .then((platformRef) => {
    // Armazena platformRef globalmente — usado por getAngularService() e getAngularJSService()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ponte platformRef NgUpgrade (§2.3); tipado na Exit Phase
    (window as any).angularPlatformRef = platformRef;

    const module = angular.module('integrador-dashboard');

    // ─── Registro de componentes Angular como diretivas AngularJS ────────────
    DOWNGRADES.forEach(({ selector, component }) => {
      module.directive(
        selector,
        downgradeComponent({
          component,
          propagateDigest: false, // evita digest loops
        }) as angular.IDirectiveFactory
      );
    });
    // ─────────────────────────────────────────────────────────────────────────

    const upgrade = platformRef.injector.get(UpgradeModule);
    upgrade.bootstrap(document.documentElement, ['integrador-dashboard'], { strictDi: false });

    platformRef.injector.get(AppService).syncWithRootScope();

    // Libera o ui-router para processar a rota atual após o bootstrap completo
    const $injector = angular.element(document.documentElement).injector();
    $injector.get('$urlService').listen();
    $injector.get('$urlService').sync();
  })
  .catch((err) => console.error('[NgUpgrade] Erro no bootstrap:', err));
